module.exports = {
	"aFile": "a file",
	"aFile_plural": "files",
	"clickToClearError": "Click <a>here</a> to clear $t(upload::demonstrateError).",
	"demonstrateError": "this error",
	"demonstrateError_plural": "these errors",
	"dropMessage": "Try dropping $t(upload::aFile) here, or click the button to select $t(upload::aFile) to upload.",
	"errors": {
		"size": "The file is too big. The limit is __limit__.",
		"type": "The file format is invalid, it must be either a JPEG or a PNG.",
		"quantity": "You have exceeded your file limit.",
		"unknown": "Unknown cause"
	},
	"fileError": "The following file caused an error.",
	"fileError_plural": "The following files caused errors.",
	"pictureLimit": "Picture limit",
	"progressMessage": "Upload progress",
	"reorderMessage": "You can drag images around to reorder them. The first one will be used for the thumbnail in listings.",
	"status": {
		"done": "Upload complete",
		"error": "Upload error",
		"ongoing": "Uploading",
		"pending": "Pending upload"
	},
	"unsavedChanges": "Your picture changes are not saved yet, you need to submit the form.",
	"uploadButton": "Upload"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/upload.json5
// module id = 1962
// module chunks = 6